export type HttpMethod = 'DELETE' | 'GET' | 'HEAD' | 'OPTIONS' | 'PATCH' | 'POST' | 'PUT';

export type HttpHeaders = Record<string, string | number | undefined | null>;
export type HttpHeadersMap = Record<string, string>;

export type HttpResponse<TData> = {
  data: TData;
  headers: HttpHeadersMap;
  status: number;
};

export class HttpRequestError extends Error {
  data?: unknown;
  headers: HttpHeadersMap;
  status?: number;

  constructor(
    message: string,
    {
      data,
      headers = {},
      status,
    }: {
      data?: unknown;
      headers?: HttpHeadersMap;
      status?: number;
    } = {},
  ) {
    super(message);
    this.data = data;
    this.headers = headers;
    this.status = status;

    Object.setPrototypeOf(this, HttpRequestError.prototype);
  }
}

export const isAbortError = (error: unknown): boolean =>
  (error instanceof DOMException || error instanceof Error) && error.name === 'AbortError';

/** Browser fetch failures when the network is unavailable or the request cannot complete. */
export const isNetworkError = (error: unknown): boolean => {
  if (!(error instanceof TypeError)) {
    return false;
  }

  const { message } = error;
  // Sentry's fetch instrumentation appends ` (hostname)` to these messages before our catch runs.
  return (
    message === 'Failed to fetch' ||
    message.startsWith('Failed to fetch (') ||
    message === 'Load failed' ||
    message.startsWith('NetworkError when attempting to fetch resource')
  );
};

export const isHttpRequestError = (error: unknown): error is HttpRequestError =>
  error instanceof HttpRequestError;
